import React, { useState } from 'react';
import { Box, Typography, TextField, Modal, Fade, Backdrop, Button } from '@mui/material';

interface RoleModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (name: string, description: string) => Promise<void>;
}

const RoleModal: React.FC<RoleModalProps> = ({ open, onClose, onSave }) => {
  const [newRoleName, setNewRoleName] = useState('');
  const [newRoleDescription, setNewRoleDescription] = useState('');

  const handleSave = async () => {
    await onSave(newRoleName, newRoleDescription);
    setNewRoleName('');
    setNewRoleDescription('');
    onClose();
  };

  const handleClose = () => {
    setNewRoleName('');
    setNewRoleDescription('');
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={open}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" gutterBottom sx={{ color: (theme) => theme.palette.custom.titleText }}>
            Add New Role
          </Typography>
          <TextField
            fullWidth
            label="Role Name"
            size="small"
            value={newRoleName}
            onChange={(e) => setNewRoleName(e.target.value)}
            sx={{ mb: 2, bgcolor: (theme) => theme.palette.custom.textFieldBackground }}
            required
          />
          <TextField
            fullWidth
            label="Role Description"
            size="small"
            value={newRoleDescription}
            onChange={(e) => setNewRoleDescription(e.target.value)}
            sx={{ mb: 2, bgcolor: (theme) => theme.palette.custom.textFieldBackground }}
            required
          />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
            <Button onClick={handleClose} sx={{ textTransform: 'uppercase' }}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleSave}
              disabled={!newRoleName || !newRoleDescription}
              sx={{ textTransform: 'uppercase', bgcolor: (theme) => theme.palette.custom.buttonBackground }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default RoleModal;